import { InviteWorkspaceMemberStrategy } from './InviteWorkspaceMemberStrategy';

export default class InviteMultipleWorkspaceMemberStrategy extends InviteWorkspaceMemberStrategy {
	protected renderSeatAssignedMessage() {
		this.showSuccessMessage( {
			title: this.seatAssignedMessageTitle,
			description: 'The selected members now have full Member permissions.'
		} );
	}

	protected renderSuccessMessageWithEnoughSpace() {
		const membersMessage = this.membersToAdd === 1 ? '1 new member' : `${this.membersToAdd} new members`;

		this.showSuccessMessage( {
			title: this.successMessageTitle,
			description: `You've successfully invited ${membersMessage} to your workspace.`
		} );
	}

	protected renderSuccessMessageWithoutEnoughSpace() {
		const seatsMessage = this.seatsToAdd > 1 ? `${this.seatsToAdd} seats` : '1 seat';
		const membersMessage = this.membersToAdd === 1 ? '1 new member' : `${this.membersToAdd} new members`;

		this.showSuccessMessage( {
			title: this.successMessageTitle,
			description: `You've successfully added ${seatsMessage} and invited ${membersMessage} to your workspace.`
		} );
	}

	protected renderAlreadyInvitedErrorMessage() {
		this.showErrorMessage( {
			title: this.errorMessageTitle,
			description: 'At least one email you\'ve entered has already been invited.'
		} );
	}

	protected renderDefaultErrorMessage() {
		this.showErrorMessage( {
			title: this.errorMessageTitle,
			description: 'An error occurred while inviting members. Please try again later.'
		} );
	}
}
